import { useState } from "react";
import { isLeaf, maxAssegnabili } from "../../utils/gerarchiautils";
import { API_BASE } from "../../utils/draftutils";
import "./nodeblock.css";

export default function NodeBlock({ all, node, onAddChildren, onRemove, onLeafClick, 
    readOnly = false, showConversions = true, selectedLeafId = null,  disabledLeafId = null }) {

  const nonfoglia = !isLeaf(node); 
  const capacity = nonfoglia ? maxAssegnabili(all, node) : 0;
  const canAdd = nonfoglia && capacity > 0;
  const isDisabled = !nonfoglia && disabledLeafId === node.tempId;
  const isSelected = !nonfoglia && selectedLeafId === node.tempId;

  const [showPopup, setShowPopup] = useState(false);
  const [conversions, setConversions] = useState([]);
  const [hovered, setHovered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const handleClick = () => {
   if (isDisabled) return; 
   if (canAdd) {
     onAddChildren(node);
   } else if (!nonfoglia && onLeafClick) {
     onLeafClick(node);
   }};

  const handleMouseEnter = async () => {
    if ((isLeaf(node) && readOnly) || (!isLeaf(node) && !readOnly && canAdd)) {setHovered(true);}
    if (!showConversions) return;
    if (!isLeaf(node)) return; // popup solo sulle foglie
    setShowPopup(true);
    setLoading(true);
    setErr("");

    try {
      const id = node.tempId.replace("F-", ""); // estrai id numerico
      const res = await fetch(`${API_BASE}/api/gerarchia/factors-list?leafId=${id}`, {
        credentials: "include",
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setConversions(data);
    } catch (e) {
      setErr("Errore caricamento conversioni");
    } finally {
      setLoading(false);
    }
  };

  const handleMouseLeave = () => {
    if ((isLeaf(node) && readOnly) || (!isLeaf(node) && !readOnly && canAdd)) {setHovered(false);}
    if (!showConversions) return;  
    setShowPopup(false);
    setConversions([]);
  };

    const baseBg = nonfoglia ? "#e6f7ff" : "#ffe6e6";
    const baseBorder = nonfoglia ? "#1890ff" : "#ff4d4f";
    const bg = isSelected ? "#fff3cd" : baseBg;       
    const border = isDisabled ? "#6c757d" : (isSelected ? "#ffc107" : baseBorder);

  return (
  <div
    className={isSelected ? "blink-selected" : ""}
    onClick={handleClick}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    style={{
      border: `2px solid ${border}`,
      background: isDisabled
      ? "#e0e0e0"
      : nonfoglia
        ? baseBg
        : isSelected
          ? (hovered ? "#feecbbff" : "#fff3cd") // foglia selezionata → giallo più scuro in hover
          : (hovered ? "#ffd6d6" : baseBg),   // foglia non selezionata → rosato in hover
      padding: 10,
      minWidth: 220,
      display: "inline-block",
      cursor: isDisabled ? "not-allowed" : (((!nonfoglia && onLeafClick) || canAdd) ? "pointer" : "default"),
      transition: "background .2s ease, border-color .2s ease, box-shadow .2s ease",
      position: "relative",
      boxShadow: hovered
        ? "0 6px 18px rgba(0,0,0,0.35)"
        : (isSelected ? "0 0 12px 3px rgba(255,193,7,0.7)" : "none"),
    }}
    role={ isDisabled ? undefined : (((!nonfoglia && onLeafClick) || canAdd) ? "button" : undefined) }
    title={
      isDisabled
        ? "Questo servizio è già quello richiesto: non selezionabile come offerta"
        : (canAdd ? "Clicca per aggiungere figli"
          : (!nonfoglia && onLeafClick) ? "Clicca per selezionare" : "")
    }
    aria-disabled={isDisabled || !canAdd}
  >

    {/* Nome */}
    <h3 style={{ margin: 0 }}>{node.nome}</h3>

    {/* Dominio scelto (se presente) */}
    {node.dominioVal && (
      <p style={{ margin: "4px 0 0 0" }}>
        <strong>Scelta:</strong> {node.dominioVal}
        {node.descrizione ? ` — ${node.descrizione}` : ""}
      </p>
    )}

    {/* Campo (solo nonfoglia) */}
    {nonfoglia && node.campo && (
      <p style={{ margin: "4px 0 0 0" }}>
        <strong>Campo:</strong> {node.campo}
      </p>
    )}

    {/* Dominio interno (radice o non) */}
    {nonfoglia && node.dominio && node.dominio.length > 0 && (
      <>
        <strong style={{ marginBottom: 4, marginTop: 4 }}>Dominio:</strong>
        <ul style={{ marginTop: 0 }}>
          {node.dominio.map((v, i) => (
            <li key={i}>{v} — {(node.descrizioni || [])[i]}</li>
          ))}
        </ul>
      </>
    )}

    {/* bottone rimozione */}
    {!readOnly && (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onRemove(node.tempId); }}
          className="btn btn-light border"
        >
          Rimuovi blocco
        </button>
      </div>
    )}

    {/* Popup conversioni */}
    {showPopup && showConversions && (
      <div
        style={{
          position: "absolute",
          top: "100%", left: 0,
          background: "white",
          border: "1px solid #ccc",
          padding: 8,
          marginTop: 4,
          zIndex: 10,
          width: "250px",
          maxHeight: "200px",
          overflowY: "auto",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        }}
      >
        <p style={{ fontSize: "0.9em", marginBottom: 6, color: "#444" }}>
          <strong>Per usufruire di 1 ora di questo servizio, occorre offrire le ore indicate di uno dei seguenti servizi:</strong>
        </p>

        {loading && <p>Caricamento…</p>}
        {err && <p style={{ color: "red" }}>{err}</p>}
        {!loading && !err && conversions.length === 0 && <p>Nessun fattore trovato</p>}
        {!loading && !err && conversions.length > 0 && (
          <ul style={{ paddingLeft: 16 }}>
            {conversions.map((c) => (
              <li key={c.leafId}>
                {c.leafName}: <strong>{c.factor?.toFixed(2)}</strong>
              </li>
            ))}
          </ul>
        )}
      </div>
    )}
  </div>
);

}
